import { ApolloClient, InMemoryCache, HttpLink } from "@apollo/client";

const createAccountClient = new ApolloClient({
  link: new HttpLink({
    uri: "https://api.learnhut.de/auth/createUser", // Correct endpoint for GraphQL queries
    credentials: "include", // Ensure cookies or credentials are included
  }),
  cache: new InMemoryCache(),
});

export default createAccountClient;
